import React from "react";

import Carousel from "components/common/Carousel";

import { ReactComponent as HonestyIcon } from "assets/svgs/honesty-icon.svg";
import { ReactComponent as SustainabilityIcon } from "assets/svgs/sustainability-icon.svg";
import { ReactComponent as TransparencyIcon } from "assets/svgs/transparency-icon.svg";
import { ReactComponent as EquityIcon } from "assets/svgs/equity-icon.svg";
import { ReactComponent as AccountabilityIcon } from "assets/svgs/accountability-icon.svg";

import useWindowSize from "hooks/useWindowSize";

import * as S from "./SectionGovernancePrinciple.Style";

const cardsList = [
  {
    id: 1,
    image: HonestyIcon,
    title: "Integridade",
    description:
      "Atuação ética e coerente, com lealdade à organização e prevenção de conflitos de interesse.",
  },
  {
    id: 2,
    image: SustainabilityIcon,
    title: "Sustentabilidade",
    description:
      "Compromisso com decisões conscientes, independentes e voltadas à geração de valor sustentável.",
  },
  {
    id: 3,
    image: TransparencyIcon,
    title: "Transparência",
    description:
      "Comunicação com stakeholders, promovendo confiança mesmo além das exigências legais.",
  },
  {
    id: 4,
    image: EquityIcon,
    title: "Equidade",
    description:
      "Tratamento justo e respeitoso a todos os envolvidos, considerando direitos e deveres.",
  },
  {
    id: 5,
    image: AccountabilityIcon,
    title: "Responsabilização",
    description:
      "Desempenhar funções com diligência e prestar contas de forma clara e transparente.",
  },
];

const SectionGovernancePrinciple = () => {
  const { width } = useWindowSize();

  const isMobile = width && width <= 990;

  return (
    <S.SectionGovernancePrincipleContainer className="container">
      <S.SectionGovernancePrincipleTitle>
        Princípios
      </S.SectionGovernancePrincipleTitle>

      <S.SectionGovernancePrincipleDescription>
        Mais do que regras, para nós, governança é uma forma de agir — é o
        compromisso de tomar decisões responsáveis, prestar contas com clareza,
        equilibrar interesses com justiça e conduzir os negócios com ética e
        integridade. Para isso, seguimos 5 princípios. <strong>São eles</strong>
        :
      </S.SectionGovernancePrincipleDescription>

      <Carousel
        noControls={!isMobile}
        numberOfSlidersToDisplay={isMobile ? 1 : 5}
        spacingToSlider={16}
        justifyContentOfSlider={"space-between"}
        children={cardsList.map((cardItem) => (
          <S.SectionGovernancePrincipleCard key={cardItem?.id}>
            <cardItem.image />

            <S.SectionGovernancePrincipleCardContent>
              <S.SectionGovernancePrincipleCardTitle>
                {cardItem?.title}
              </S.SectionGovernancePrincipleCardTitle>

              <S.SectionGovernancePrincipleCardDescription>
                {cardItem?.description}
              </S.SectionGovernancePrincipleCardDescription>
            </S.SectionGovernancePrincipleCardContent>
          </S.SectionGovernancePrincipleCard>
        ))}
      />
    </S.SectionGovernancePrincipleContainer>
  );
};

export default SectionGovernancePrinciple;
